<template>
  <div class="fondo">
    <div class="contenedor">


      <div class="logo">
        <a href="/">
          <img src="../assets/logotipo_blanco.png" alt="Logo">
        </a>
      </div>


      <div class="sociales">
        <div>
          <div>
            <p class="asterisco">*</p>
          </div>

          <div>
            <p>Encuéntranos en:</p>
          </div>
        </div>

        <div class="redes">
          <a href="https://www.instagram.com/porkilo.mx/" target="_blank" rel="noopener noreferrer">
            <div>
              <img src="../assets/in.svg" alt="Instagram">
            </div>
          </a>
          <a href="https://www.tiktok.com/@porkilo.mx?_t=ZS-8wWMlbfQxPu&_r=1" target="_blank" rel="noopener noreferrer">
            <div>
              <img src="../assets/Tiktok.svg" alt="Tiktok">
            </div>
          </a>
          <a href="https://rappi.app.link/Por_Kilo_Botanas" target="_blank" rel="noopener noreferrer">
            <div>
              <img src="../assets/Rappi.svg" alt="Rappi">
            </div>
          </a>
          <a href="https://www.facebook.com/porkilomx/" target="_blank" rel="noopener noreferrer">
            <div>
              <img src="../assets/fb.svg" alt="Facebook">
            </div>
          </a>
        </div>


        <div>
          <p class="asterisco">*</p>
          <p>Por Kilo Botanas <br>
            {{ yyyy }} Copyright © <br>
            Todos los Derechos <br>
            Reservados</p>
        </div>
      </div>

      <div class="divisor"></div>

      <div class="tienda">
        <img src="../assets/kilo.png" alt="Tienda">
      </div>

      <div class="direcciones">
        <div @click="redirect('https://maps.app.goo.gl/t7jjVjnJU19XpzTVA')">
          <p class="asterisco">*</p>
          <p>Blvd Gomez Farias 26. Col. Pitic. Hermosillo, Sonora.</p>
        </div>

        <div @click="redirect('https://maps.app.goo.gl/8q3Stu4iQVhjv5V96')">
          <p class="asterisco">*</p>
          <p>Blvd. Navarrete 256. Col. Villa Satélite. Hermosillo, Sonora.</p>
        </div>
        <div @click="redirect('https://maps.app.goo.gl/6HexP2Ggchp8gR6E9')">
          <p class="asterisco">*</p>
          <p>Blvd. Luis Donaldo Colosio Murrieta 887-Local 27 Plaza La Encantada Hermosillo, Sonora.</p>
        </div>
        <div @click="redirect('https://maps.app.goo.gl/EGSeNNi4VBoXzyYF7')">
          <p class="asterisco">*</p>
          <p class="custom_size">Fernando Montes de Oca 47. Col. Condesa. CDMX</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dayjs from "dayjs";
export default {
  data() {
    return {
      yyyy: "2022",
    };
  },
  created() {
    this.yyyy = dayjs().format("YYYY");
  },
  methods: {
    redirect(enlace) {
      window.open(enlace);
    },
  },
}
</script>

<style scoped>
p {
  margin: 0;
  font-family: "Kinetica-Bold";
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #FFF9EA;
}

.asterisco {
  font-family: 'Catou';
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #BDF93E;
}

img {
  width: 100%;
}



.contenedor {
  display: flex;
}

.redes {
  display: flex;
}


/* Celular */
@media (max-width: 767px) {
  .fondo {
    background-color: #FF3723;
  }

  p {
    font-size: 2.564102564102564VW;
    line-height: 4.615384615384616VW;
  }

  .asterisco {
    font-size: 9.230769230769232VW;
    line-height: 9.230769230769232VW;
    margin: 0 0 4.67948717948718VW 0;
  }

  .sociales>div:first-of-type .asterisco {
    margin: 0 0 3.91025641025641VW 0;
  }

  .contenedor {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 9.743589743589745VW 0 30.76923076923077VW;
  }

  .logo {
    width: 69.5652vw;
  }

  .logo img {
    content: url("../assets/taco_amarillo.png");
  }

  .redes {
    display: flex;
    justify-content: center;
    column-gap: 5.5487179487179485VW;
    margin: 6.923076923076923VW 0 12.233333333333334VW;
  }

  .redes>div {
    width: 12.738461538461538VW;
    height: 12.738461538461538VW;
  }

  .tienda {
    width: 76.92307692307693VW;
    height: 57.97179487179487VW;
    margin: 12.051282051282051VW auto 13.333333333333334VW;
  }

  .direcciones {
    display: grid;
    grid-auto-rows: max-content;
    gap: 8.564102564102564VW 0;
  }
.redes img {
  width: 15.666666666666667vw;
  height: 15.666666666666667vw;
}

  .direcciones>div {
    margin: 0 22.5vw;
  }
}

/* PC */
@media (min-width: 768px) {
  .fondo {
    background-image: url("../assets/modulo_footer.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  p {
    font-size: 0.5208333333333333VW;
    line-height: 0.9375VW;
  }

  .asterisco {
    font-size: 1.875VW;
    line-height: 1.875VW;
    margin: 0 0.425VW 0 0;
  }

  .contenedor {
    width: 78.90625VW;
    height: 15.937499999999998VW;
    padding: 5.052083333333333VW 10.546875VW;
  }

  .logo {
    width: 16.5104vw;
    margin: 0 2.5VW 0 0;
    display: grid;
    place-items: center;
  }

  .sociales {
    width: 11.927083333333334VW;
    height: 11.9375VW;
    margin: 2.65625VW 3.125VW 0 0;
  }

  .sociales>div:nth-of-type(odd) {
    display: flex;
    width: 12.1vw;
  }

  .sociales>div:nth-of-type(2) {
    margin: 0.40625VW 0 1.6145833333333335VW 1.2395833333333335VW;
  }

  .redes img {
    width: 2.5vw;
    height: 2.5vw;
  }
  .redes div:first-of-type {
    margin-right: 0.78125vw;
  }

  .sociales .redes>div {
    width: 3.229166666666667VW;
    height: 3.229166666666667VW;
  }

  .divisor {
    width: 1px;
    height: 15.937499999999998VW;
    background-color: #FFFFFF;
    margin: 0 1.8229166666666667VW 0 0;
  }

  .tienda {
    width: 21.033333VW;
    margin: 0 1.4583333333333333VW 0 0;
    height: 15.700520833333334VW;
  }

  .direcciones {
    display: grid;
    grid-auto-rows: max-content;
    align-content: center;
    gap: 2.083333333333333VW;
    width: 22.5VW;
  }

  .direcciones div {
    display: flex;
    cursor: pointer;
  }

  .direcciones div:first-of-type {}

  .direcciones a::before {
    content: "\A";
    white-space: pre;
  }

  p.custom_size {
    width: 15vw;
  }
}
</style>